import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, MinValidator, ReactiveFormsModule, Validators } from '@angular/forms';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { COLUMNS_HEADER_MMPP_PRODUCTS_ADMIN} from '../../core/constants/tables.constants';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MmppProductsService } from '../../core/services/mmpp-products.service';
import { BlendersService } from '../../core/services/blenders.service';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';


@Component({
  selector: 'app-mmpp-products',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, GenericTableComponent],
  templateUrl: './mmpp-products.component.html',
  styleUrl: './mmpp-products.component.scss'
})
export class MmppProductsComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_MMPP_PRODUCTS_ADMIN;

  products: any;
  productsFiltered: any;
  blenders: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;

  faSpinner = faSpinner;
  faMagnifyingGlass = faMagnifyingGlass;

  form: FormGroup = this.formBuilder.group({
    id: [],
    mixtion: ['', Validators.required],
    zona: ['', Validators.required],
    inviernoNH: [],
    veranoNH: [],
    inviernoH: [''],
    veranoH: [''],
    super: [''],
  });

  filters: any = {
    search: {
      value: '',
      filter: (obj: any): boolean => {
        return (String(obj.id)?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.mixtion?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.zona?.toLowerCase().includes(this.filters.search.value) )
      }
    },
  };

  constructor(
    private mmppProductsSvc: MmppProductsService,
    private formBuilder: FormBuilder,
    private blendersSvc: BlendersService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getBlenders();
    this.getProducts();
  }

  onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getProducts();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El producto ${this.form.value.product} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El producto ${this.form.value.product} ha sido actualizado correctamente`);
        }
        this.form.reset();

      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        const { id, ...formData } = this.form.value; 
        this.mmppProductsSvc.createMmppProduct(formData).subscribe(responseAction);
      } else {
        this.mmppProductsSvc.updateMmppProduct(this.form.value).subscribe(responseAction);
      }
    }
  }

  getProducts() {
    this.mmppProductsSvc.getMmppProducts().subscribe((res: any) => {
      this.products = [...res];
      this.productsFiltered = res;
    });
  }

  getBlenders() {
    this.blendersSvc.getBlenders().subscribe((res: any) => {
      this.blendersSvc = res;
    });
  }

  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.mmppProductsSvc.deleteMmppProduct(item.id).subscribe({
      next: () => {
        this.getBlenders();
        this.getProducts();
        this.isLoading = false;
        this.toastr.success(`La materia prima ${item.id} ha sido eliminada correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }

  onFilter() {
    this.productsFiltered = this.products.filter((obj: any) => {
      return Object.keys(this.filters).map(f => {
        return !this.filters[f].value ? true : this.filters[f].filter(obj);
      }).filter(f => f).length === Object.keys(this.filters).length;
    });
  }

  resetFilters(keysSelected: any) {
    for (const key of Object.keys(this.filters)) {
      if (!keysSelected.includes(key)) {
          this.filters[key] = '';
      }
    }
  }

}
